var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.bgColor,"top":""},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n  "),_c('v-btn',{attrs:{"dark":"","flat":"","icon":""},on:{"click":function($event){_vm.showPopup = false}}},[_c('v-icon',[_vm._v("cancel")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }